<template>
    <div class="ocr-result" v-if="ocrStatus">
        <div :class="['ocr-result-icon', ocrStatus === OCR_STATUS.SUCCESS ? 'ocr-success' : 'ocr-fail']"></div>
        <div class="ocr-result-desc">
            {{ desc }}
        </div>
    </div>
</template>
<script>
import { OCR_STATUS } from '../../../const';

export default {
    props: {
        desc: {
            type: String,
            default: '',
        },
        ocrStatus: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            OCR_STATUS,
        };
    },
    methods: {
    },
};
</script>
<style lang="less" scoped>
.ocr-result {
    color: var(--font-notice, #9C9C9C);
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    margin-top: 12px;
    display: flex;
    &-icon {
        width: 16px;
        height: 18px;
        margin-right: 4px;
        flex-shrink: 0;
        transform: translateY(1px)
    }
    &-desc {
        line-height: 18px;
    }
}
.ocr-success {
    background: var(--csc-collect-ocr-success) no-repeat;
}
.ocr-fail {
    background: var(--csc-collect-ocr-fail) no-repeat;
}
</style>
